export const AdministratorModelConstants = {
    BASE_ADMINISTRATOR: 7,
    ADMIN_DEPARTMENT_ADMIN: 1,
    ADMIN_DEPARTMENT_MKT: 2,
    ADMIN_DEPARTMENT_VALID: 3,
    ADMIN_DEPARTMENT_SALES: 4,
    ADMIN_DEPARTMENT_IT: 5,
    ADMIN_DEPARTMENT_EXTERNAL: 10,
}